import React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';
import {
  getNavLinkListItemStyles,
  getListItemIconStyles,
  listItemTextStyles,
  listItemTextTypographyProps,
  shouldShowText,
} from './navigationStyles';

/**
 * TopNavigationIcon component for rendering the top icon in the sidebar
 * This icon navigates to the chat page and shows active state when on /chat
 *
 * @param {Object} props - Component props
 * @param {Object} props.item - Navigation item data
 * @param {boolean} props.miniDrawer - Whether the drawer is in mini mode
 * @param {boolean} props.isDesktop - Whether the current view is desktop
 * @param {Function} props.onClick - Optional click handler
 * @returns {JSX.Element} TopNavigationIcon component
 */
const TopNavigationIcon = ({
  item,
  miniDrawer,
  isDesktop,
  onClick
}) => {
  const theme = useTheme();
  const { label, icon: Icon } = item;

  return (
    <ListItem
      component={NavLink}
      to="/chat"
      onClick={onClick}
      sx={getNavLinkListItemStyles(theme, { miniDrawer, isDesktop })}
    >
      <ListItemIcon sx={getListItemIconStyles({ miniDrawer, isDesktop })}>
        <Icon />
      </ListItemIcon>
      {shouldShowText(isDesktop, miniDrawer) && (
        <ListItemText
          sx={listItemTextStyles}
          primaryTypographyProps={listItemTextTypographyProps}
          primary={label}
        />
      )}
    </ListItem>
  );
};

export default TopNavigationIcon;
